// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49b87819","635":"f878d318"}[chunkId] + ".chunk.js";
};